export { default } from "./table-body";
